import React from 'react'
import { NewPurchaseOrderWizard } from '../wizard/NewPurchaseOrderWizard'

interface NewPurchaseOrderModalProps {
  _open: boolean
  onOpenChange: (_open: boolean) => void
}

export const NewPurchaseOrderModal: React.FC<NewPurchaseOrderModalProps> = ({
  _open,
  onOpenChange,
}) => {
  return (
    <NewPurchaseOrderWizard
      documentType="orden-compra"
      onOpenChange={onOpenChange}
      open={_open}
    />
  )
}

export default NewPurchaseOrderModal
